import { ariaGetControlledElement, ariaSet } from '../utils/aria'

/**
 * Base tab functionality
 */

const makeTabActive = (tab) => {
    ariaSet('selected', tab, 'true')
    ariaSet('hidden', ariaGetControlledElement(tab), 'false')
    tab.tabIndex = '0'
}

const makeTabInctive = (tab) => {
    ariaSet('selected', tab, 'false')
    ariaSet('hidden', ariaGetControlledElement(tab), 'true')
    tab.tabIndex = '-1'
}

const tabList = () => {
    document.querySelectorAll('[data-module="tabs"]').forEach((section) => {
        const tabItems = section.querySelectorAll('[data-tab]')
        tabItems.forEach((tab, index) => {
            if (index === 0) {
                makeTabActive(tab)
            }
            tab.addEventListener('keydown', (event) => {
                switch (event.key) {
                    case 'ArrowLeft':
                        if (index === 0) break
                        tabItems[index - 1].focus()
                        break
                    case 'ArrowRight':
                        if (index === section.length) break
                        tabItems[index + 1].focus()
                        break
                    default:
                        break
                }
            })

            tab.addEventListener('click', () => {
                // Disable all tabs
                tabItems.forEach((tab) => {
                    makeTabInctive(tab)
                })

                // Enable clicked tab
                makeTabActive(tab)
                updatedRelatedSelect(tab)

                if (tab.id) {
                    history.pushState({}, '', `#${tab.id}`)
                }
            })
        })
    })
}

/**
 * Updates the tabs in case a custom dropdown within the module changes
 */
const relatedSelect = () => {
    document.querySelectorAll('[data-module="tabs"]').forEach((section) => {
        const select = section.querySelector('select')
        if (!select) return
        const options = Array.from(select.options)

        select.addEventListener('change', () => {
            const selectedTabButton = document.querySelector(`[aria-controls='${select.value}']`)
            const selectedTabPanel = document.querySelector(`#${select.value}`)
            const matchingOption = options.find(option => option.value === select.value)?.text?.toLowerCase()

            if (!selectedTabButton || !selectedTabPanel) return

            // Disable all tabs
            section.querySelectorAll('[data-tab]').forEach((tab) => {
                ariaSet('selected', tab, 'false')
                ariaSet('hidden', ariaGetControlledElement(tab), 'true')
            })

            // Enable selected tab
            ariaSet('selected', selectedTabButton, 'true')
            ariaSet('hidden', selectedTabPanel, 'false')

            if (matchingOption) {
                history.pushState({}, '', `#${matchingOption}`)
            }
        })
    })
}

/**
 * Updates the custom dropdown in case it's included within the module
 */
function updatedRelatedSelect(tab) {
    if (!tab) return

    const section = tab.closest('[data-module="tabs"]')
    const select = section.querySelector('select')
    const label = section.querySelector('[data-label]')
    const options = section.querySelectorAll('[data-option]')
    const value = tab.getAttribute('aria-controls')

    if (select && value && options) {
        // Update native select value
        select.value = value

        // Update custom dropdown active state
        options.forEach((option) => {
            if (option.dataset.value === value) {
                option.setAttribute('data-active', '')

                // Update custom dropdown label
                label.textContent = option.textContent
            } else {
                option.removeAttribute('data-active')
            }
        })
    }
}

function checkActiveTabFromUrl() {
    const tabs = document.querySelectorAll('[data-module="tabs"]')
    if (!tabs) return

    const hash = window.location.hash.split('#')[1]
    if (!hash) return

    tabs.forEach((tab) => {
        const labels = tab.querySelectorAll('[data-tab]')
        if (!labels.length) return

        const hashMatch = Array.from(labels).find(label => label.id === hash)
        if (!hashMatch) return

        const select = tab.querySelector('select')
        if (select) {
            setOptionByParam(select, hash)
        }

        labels.forEach((label) => {
            const { id } = label
            if (id === hash) {
                makeTabActive(label)
            } else {
                makeTabInctive(label)
            }
        })
    })
}

function setOptionByParam(select, param) {
    if (!select || !param) return

    const options = Array.from(select.options)
    const matchingOption = options.find(option => option.text.toLowerCase().includes(param.toLowerCase()))

    if (matchingOption) {
        select.value = matchingOption.value
        select.dispatchEvent(new Event('change'))
    }
}

export default (function () {
    tabList()
    relatedSelect()
    checkActiveTabFromUrl()
})
